// montonioApi.js - API functions for Montonio key management
import { API_URL } from '../config/apiConfig';
import axios from 'axios';


/**
 * Get Montonio API keys status for affiliate
 * Returns whether keys exist, but not the actual values
 */
export const getMontonioApiKeys = async (affiliateId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
            `${API_URL}/montonio/${affiliateId}/keys`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching Montonio API keys status:', error);
        throw error;
    }
};

/**
 * Create or update Montonio API keys
 */
export const updateMontonioApiKeys = async (affiliateId, accessKey, secretKey) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
            `${API_URL}/montonio/${affiliateId}/keys`,
            {
                accessKey,
                secretKey
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error updating Montonio API keys:', error);
        throw error;
    }
};

/**
 * Delete Montonio API keys
 */
export const deleteMontonioApiKeys = async (affiliateId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.delete(
            `${API_URL}/montonio/${affiliateId}/keys`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error deleting Montonio API keys:', error);
        throw error;
    }
};

